import React, {useState} from 'react';
import { Typography, Button, ButtonMenu } from '@ann/web-components';
import Breadcrumb from '../Breadcrumb';
import NewDriveModal from '../NewDriveModal';
import NewFolderModal from '../NewFolderModal';
import { DrivesTabsEnum } from '../../enums/drivesTabs';
import { observer } from 'mobx-react';
import { useDrivesStores } from '../../hook/use-drives.hook';
import { useStoreNotifications } from '../../hook/use-store-notifications.hook';

import {
    HeaderContainer,
    HeaderLeft,
    HeaderRight,
    TitleContainer,
    SubtitleContainer
} from './Header.styled';

const Header = observer(({ selectedTab, onTabChange }) => {
    const drivesPageStore = useDrivesStores();
    const myWorkspacesStore = drivesPageStore?.myWorkspacesStore;
    const drivesStore = drivesPageStore?.drivesViewStore?.drivesStore;
    const foldersStore = drivesPageStore?.myWorkspacesStore?.foldersStore;
    const [ showNewDriveModal, setShowNewDriveModal ] = useState(false);
    const [ showNewFolderModal, setShowNewFolderModal ] = useState(false);
   


    // Toast notifications for Drive and Folder operations
    useStoreNotifications([
        {
            condition: drivesStore?.createdDrive,
            type: 'success',
            description: `${drivesStore?.driveCreated?.name} was created`,
            onClose: () => drivesStore?.setCreatedDrive(false)
        },
        {
            condition: drivesStore?.driveAlreadyExists,
            type: 'error',
            title: "A drive with this name already exists.",
            description: "Please choose a different name.",
            onClose: () => drivesStore?.setDriveAlreadyExists(false)
        },
        {
            condition: drivesStore?.isErrorCreateDrive,
            type: 'error',
            title: "Connection error, drive could not be created.",
            description: "Please try again or check your connection.",
            onClose: () => drivesStore?.setIsErrorCreateDrive(false)
        },
        {
            condition: foldersStore?.createdFolder,
            type: 'success',
            description: `${foldersStore?.folderCreated?.name} was created`,
            onClose: () => foldersStore?.setCreatedFolder(false)
        },
        {
            condition: foldersStore?.folderAlreadyExists,
            type: 'error',
            title: "A folder with this name already exists.",
            description: "Please choose a different name.",
            onClose: () => foldersStore?.setFolderAlreadyExists(false)
        },
        {
            condition: foldersStore?.isErrorCreateFolder,
            type: 'error',
            title: "Connection error, folder could not be created.",
            description: "Please try again or check your connection.",
            onClose: () => foldersStore?.setIsErrorCreateFolder(false)
        }
    ]);


    return (
        <>
            {/* <Breadcrumb selectedTab={selectedTab} onTabChange={onTabChange} /> */}
            <HeaderContainer>
                <HeaderLeft>
                    <TitleContainer>
                        <Typography
                            category="title"
                            size="large"
                            weight="bold"
                        >
                            AIMS Drive
                        </Typography>
                    </TitleContainer>
                    {myWorkspacesStore.currentPage !== 'upload' && (
                      <SubtitleContainer>
                      <Typography
                          category="body"
                          size="medium"
                          weight="regular"
                      >
                          Securely store, manage, and organize your documents and folders
                      </Typography>
                      </SubtitleContainer>
                    )}
                   
                </HeaderLeft>

                <HeaderRight>
                    {selectedTab === DrivesTabsEnum.DRIVES && (
                        <Button
                            icon=""
                            iconRight="plus"
                            label="New Drive"
                            size="medium"
                            type="gradient"
                            onClick={() => {
                                setShowNewDriveModal(true);
                            }}
                        />
                    )}

                    {selectedTab === DrivesTabsEnum.MY_WORKSPACE && (
                        <ButtonMenu
                            label="New"
                            menuPosition="bottom"
                            onChange={(value) => {
                                if (value === 'new-folder') {
                                    setShowNewFolderModal(true);
                                }
                                if (value === 'upload-documents') {
                                    myWorkspacesStore?.openFileSelector();
                                }
                            }}
                            size="medium"
                            type="gradient"
                            width="auto"
                            customIcon="plus"
                        >
                            <ButtonMenu.Menu icon={true} minWidth={"260px"}>
                                <ButtonMenu.Item
                                    label="Upload Documents"
                                    value="upload-documents"
                                    icon='publish'
                                />
                                <ButtonMenu.Item
                                    label="New Folder"
                                    value="new-folder"
                                    icon='createNewFolder'
                                />
                            </ButtonMenu.Menu>
                        </ButtonMenu>
                    )}
                </HeaderRight>
            </HeaderContainer>

            <NewDriveModal
                isOpen={showNewDriveModal}
                onClose={() => setShowNewDriveModal(false)}
                onSave={() => {
                    setShowNewDriveModal(false);
                }}
                size="medium"
            />

            <NewFolderModal
                isOpen={showNewFolderModal}
                onClose={() => setShowNewFolderModal(false)}
                onSave={() => {
                    setShowNewFolderModal(false);
                }}
                size="medium"
            />
        </>
    );
});

export default Header;
